// extracted by css-extract-rspack-plugin
export default {"rowDetailsItem":"k7qvTvXM_stkODya","comma":"N1h13Oz4L12pCgw8"};